//import react router dom
// import { Routes, Route, Navigate } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ComponentRenderer from "ComponentRenderer";
import ThankYouPage from "ThankYouPage";
import RestaurantLandingPage from "demos/RestaurantLandingPage";
import MainLandingPage from "MainLandingPage";
import AgencyLandingPage from "demos/AgencyLandingPage";
import IndexHome from "views/Home/Index";

// import { useStore } from "../stores/user";

//table
// import IndexDivision from "../views/Table/Division/Index.jsx";

export default function RoutesIndex() {
  return (
    <Router>
      <Routes>
        {/* <Route
          path="/components/:type/:subtype/:name"
          element={<ComponentRenderer />}
        />
        <Route path="/components/:type/:name" element={<ComponentRenderer />} />
        <Route path="/thank-you" element={<ThankYouPage />} /> */}
        <Route path="/" element={<IndexHome />} />
        {/* <Route path="/dashboard" element={<MainLandingPage />} /> */}
      </Routes>
    </Router>
  );
}
